<template>
  <a-tooltip v-if="props.remark && props.remarkToolTipFlag">
    <template #title>{{ props.remark }}</template>
    <span
      class="remix-icon ri-question-line1 xm-label-remark-tip"
      :style="remarkSty"
      @click.stop
    ></span>
  </a-tooltip>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'el-label-remark-tip',
});
</script>

<script lang="ts" setup>
import {Tooltip as ATooltip} from 'ant-design-vue';

interface propTypes {
  props: any,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  props: {},
});
const {props} = toRefs(propsPage);

const remarkSty = computed(() => {
  const sty: Record<string, string> = {};
  if (unref(props).remarkFontSize) {
    sty.fontSize = unref(props).remarkFontSize + 'px';
  }
  if (unref(props).remarkFontColor) {
    sty.color = unref(props).remarkFontColor;
  }
  return sty;
});
</script>

<style type="text/css" lang="less">
.xm-label-remark-tip {
  flex-shrink: 0;
  margin-inline-start: 4px;
  color: #666;
  cursor: help;
  line-height: 1;
}

.xm-form-label-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.xm-form-item-has-remark-tip > .ant-form-item-label > label,
.xm-form-item .ant-form-item-label > label,
.ant-form-item-label > label:has(.xm-label-remark-tip) {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
}
</style>
